/**
 * rem(px) — the one-off sizing helper for app-layer code (DESIGN.md §3.6).
 * The root is 16px × interface scale, so `rem(20)` renders 20px at 100%
 * and follows the dial elsewhere. Prefer a base.css token when one matches.
 *
 * Also multiplies by `--sf-u` (REM_UNIT_VAR), a unitless CSS custom property
 * that defaults to 1 everywhere (byte-identical output) but can be scoped to
 * a surface root (e.g. DataTable, via scaledTokens()) so every rem() value
 * under that root follows a per-surface slider without touching the root
 * interface-scale dial.
 */
export const REM_BASE_PX = 16;
export const REM_UNIT_VAR = '--sf-u';

export function rem(px: number): string {
  const v = Math.round((px / REM_BASE_PX) * 10000) / 10000;
  return `calc(${v}rem * var(${REM_UNIT_VAR}, 1))`;
}
